﻿<script setup>
    const router = useRouter();

    router.push('/shipping/released');
</script>

<template>
    
</template>